module.exports = Promise.all([parcelRequire.load("5mUqE"), parcelRequire.load("1SPWO"), parcelRequire.load("eUt3J")]).then(() => parcelRequire('jdiT1'));